import { useEffect, useState } from "react"
import { FaArrowDown, FaArrowUp, FaMinus, FaPlus } from "react-icons/fa"
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app"
import { getDatabase, increment, onValue, ref, set } from "firebase/database"
import { TCBackCounter } from "../../types/CounterTypes"
import { cn } from "../../utils/cn"
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC-zsF1AdGcb5tg9Vo6bB1usgiK3VoiQ5c",
  authDomain: "kfk-environment.firebaseapp.com",
  databaseURL:
    "https://kfk-environment-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "kfk-environment",
  storageBucket: "kfk-environment.appspot.com",
  messagingSenderId: "209981891412",
  appId: "1:209981891412:web:dd288e5984c387af509ec1",
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)
const db = getDatabase(app)

interface ExtendedProps {
  id: string
  object: typeof TCBackCounter
}

export default function TCBack({ id, object }: ExtendedProps) {
  const [counterObject, setCounterObject] = useState(object)

  const updateCounter = async ({
    delta_inside,
    delta_outside,
  }: {
    delta_inside: number
    delta_outside: number
  }) => {
    const counterRef = ref(db, `counters/${id}`)
    await set(counterRef, {
      type: "tc-back",
      inside: increment(delta_inside),
      outside: increment(delta_outside),
    })
  }

  useEffect(() => {
    onValue(ref(db, `counters/${id}`), (snapshot) => {
      const data = snapshot.val()
      setCounterObject(data)
    })
  }, [])

  return (
    <div className="bg-slate-900 w-full h-fit min-h-screen flex flex-col items-center justify-center">
      <div className="max-w-xs w-full flex flex-col gap-6 my-6">
        {counterObject ? (
          <>
            <div>
              <div className={`font-medium text-xl text-white `}>TC</div>
              <div
                className={cn(
                  "font-medium text-center text-6xl text-white",
                  counterObject.inside > 120 ? "text-amber-400" : "",
                  counterObject.inside > 139 ? "text-red-500" : ""
                )}
              >
                {counterObject.inside}
              </div>
              <div className="flex justify-between w-full gap-16 mt-3">
                <button
                  className="bg-red-500 text-white w-full rounded-lg h-16 flex justify-center items-center"
                  onClick={async () => {
                    await updateCounter({
                      delta_outside: 0,
                      delta_inside: -1,
                    })
                  }}
                >
                  <FaMinus />
                </button>
                <button
                  className="bg-green-500 text-white w-full rounded-lg h-16 flex justify-center items-center"
                  onClick={async () => {
                    await updateCounter({
                      delta_outside: 0,
                      delta_inside: 1,
                    })
                  }}
                >
                  <FaPlus />
                </button>
              </div>
            </div>
            <div>
              <div className={`font-medium text-xl text-white `}>Byt</div>
              <div className="flex justify-between w-full gap-16 mt-3">
                <button
                  className="bg-blue-500 text-white w-full rounded-lg h-16 flex justify-center items-center"
                  onClick={async () => {
                    await updateCounter({
                      delta_outside: 1,
                      delta_inside: -1,
                    })
                  }}
                >
                  <FaArrowDown />
                </button>
                <button
                  className="bg-blue-500 text-white w-full rounded-lg h-16 flex justify-center items-center"
                  onClick={async () => {
                    await updateCounter({
                      delta_outside: -1,
                      delta_inside: 1,
                    })
                  }}
                >
                  <FaArrowUp />
                </button>
              </div>
            </div>
            <div>
              <div className="font-medium text-xl text-white">Baksida</div>
              <div
                className={cn(
                  "font-medium text-center text-6xl text-white",
                  counterObject.outside > 179 ? "text-amber-400" : "",
                  counterObject.outside > 199 ? "text-red-500" : ""
                )}
              >
                {counterObject.outside}
              </div>
              <div className="flex justify-between w-full gap-16 mt-3">
                <button
                  className="bg-red-500 text-white w-full rounded-lg h-16 flex justify-center items-center"
                  onClick={async () => {
                    await updateCounter({
                      delta_outside: -1,
                      delta_inside: 0,
                    })
                  }}
                >
                  <FaMinus />
                </button>
                <button
                  className="bg-green-500 text-white w-full rounded-lg h-16 flex justify-center items-center"
                  onClick={async () => {
                    await updateCounter({
                      delta_outside: 1,
                      delta_inside: 0,
                    })
                  }}
                >
                  <FaPlus />
                </button>
              </div>
            </div>
            <div>
              <div className="font-medium text-xl text-white">Totalt</div>
              <div
                className={cn(
                  "font-medium text-center text-6xl text-white",
                  counterObject.inside + counterObject.outside > 319
                    ? "text-amber-400"
                    : "",
                  counterObject.inside + counterObject.outside > 339
                    ? "text-red-500"
                    : ""
                )}
              >
                {counterObject.inside + counterObject.outside}
              </div>
            </div>
          </>
        ) : (
          <div>Hittade inte countern...</div>
        )}
      </div>
    </div>
  )
}
